export const VideoData = [
    {
      "id": "600ac3b4fa75a43a449fa992",
      "title": 'Bella Ciao - La Casa de Papel',
      "avatar": 'https://i.pravatar.cc/150?img=55',
      "image": "https://i.ytimg.com/vi/spCdFMnQ1Fk/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLAat-NLcd-VYvg0yznjTE3_sGIC-g",
      "gif": 'https://i.ibb.co/VMX67mB/La-casa-de-papel.gif',
      "link": 'https://www.youtube.com/watch?v=spCdFMnQ1Fk',
      "channel": 'Money Heist',
      "views": "729K",
      "age": 8
    },
    {
      "id": "600ac3b4bcd1badb7e7b0678",
      "title": 'Dua Lipa, Coldplay, Martin Garrix & Kygo, The Chainsmokers Style - Feeling Me #35',
      "avatar": 'https://i.pravatar.cc/150?img=53',
      "image": "https://i.ytimg.com/vi/7sbbb7Dt3D8/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCFjpwe9e-UcyNcvRxj67L2diY0Uw",
      "gif": "https://i.ibb.co/zRt8N4Z/Dua-Lipa.webp",
      "link": 'https://www.youtube.com/watch?v=7sbbb7Dt3D8',
      "channel": 'Queen Club',
      "views": "29K",
      "age": 10
    },
    {
      "id": "600ac3b4a74f41c0a66dd123",
      "title":'[OFFICIAL VIDEO] The Sound of Silence - Pentatonix',
      "avatar": 'https://i.pravatar.cc/150?img=35',
      "image": "https://i.ytimg.com/vi/gdVjVtpr55M/hqdefault.jpg?sqp=-oaymwEYCKgBEF5IVfKriqkDCwgBFQAAiEIYAXAB&rs=AOn4CLBii81YCjSZdivSZFEas6MfGwKfDw",
      "gif": "https://i.ibb.co/pvjfYgv/Pentatonix.webp",
      "channel": 'PTXofficial',
      "link": 'https://www.youtube.com/watch?v=gdVjVtpr55M',
      "views": "308K",
      "age": 1
    },
    {
      "id": "600ac3b4c1ff23813207f456",
      "avatar": 'https://i.pravatar.cc/150?img=41',
      "title": 'Norway 4K - Scenic Relaxation Film with Calming Music',
      "image": "https://i.ytimg.com/vi/CxwJrzEdw1U/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCGOxPhRn3NQcqLapTA0oaK9aei0A",
      "gif": "https://i.ibb.co/fp45Yn4/Norway.webp",
      "link": 'https://www.youtube.com/watch?v=CxwJrzEdw1U',
      "channel": 'Scenic Relaxation',
      "views": "420K",
      "age": 9
    },
    {
      "id": "600ac3b4c90e530062825789",
      "avatar": 'https://i.pravatar.cc/400?img=1',
      "title": '7 Greatest Messi Revenge Moments - With Commentaries',
      "image": "https://i.ytimg.com/vi/0wrqw2mp3lE/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDCw58DGusxyAaGpN1cS8gbvnD2Kw",
      "gif": "https://i.ibb.co/Fs0QDf7/Messi.webp",
      "link": 'https://www.youtube.com/watch?v=0wrqw2mp3lE',
      "channel": 'SherAli EDITS',
      "views": "967K",
      "age": 3
    },
    {
      "id": "600ac3b4c90e530062825987",
      "avatar": 'https://i.pravatar.cc/400?img=42',
      "title": 'I restored this $7 Junk Playstation 2 Slim - Retro Console Restoration & Repair',
      "image": "https://i.ytimg.com/vi/8hGGVW_mGEI/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLA-6i7PQpGW2WGfsNeuEquVnb_92w",
      "gif": "https://i.ibb.co/VH3kXBr/Restoration.webp",
      "link": 'https://www.youtube.com/watch?v=8hGGVW_mGEI',
      "channel": 'Odd Tinkering',
      "views": "175K",
      "age": 6
    },
    {
      "id": "600ac3b4c90e530062825654",
      "avatar": 'https://i.pravatar.cc/400?img=43',
      "title": 'The New Mercedes S Class 2021 Test Drive',
      "image": "https://i.ytimg.com/vi/fzD6S1dMhrw/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCDk33wBIqEHEx-9cmYGATdtS03KQ",
      "gif": "https://i.ibb.co/QQm7gW7/Mercedes.webp",
      "link": 'https://www.youtube.com/watch?v=fzD6S1dMhrw',
      "channel": 'Alaatin61',
      "views": "5M",
      "age": 11
    },
    {
      "id": "600ac3b4c90e530062825321",
      "avatar": 'https://i.pravatar.cc/400?img=44',
      "title": 'Cup of Coffee | Mr Bean Full Episodes | Mr Bean Official',
      "image": "https://i.ytimg.com/vi/2k9MpD1gM14/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLD1OTL-8zg9SX-XON7hIUEM_QrbIw",
      "gif": "https://i.ibb.co/f2BfN6G/Mr-Bin.webp",
      "link": 'https://www.youtube.com/watch?v=2k9MpD1gM14',
      "channel": 'Mr Bean',
      "views": "30M",
      "age": 8
    },
    {
      "id": "600ac3b4c90e530062825132",
      "avatar": 'https://i.pravatar.cc/400?img=57',
      "title": 'TOP GUN 2 MAVERICK : 8 Minute Trailers (4K ULTRA HD) NEW 2021',
      "image": "https://i.ytimg.com/vi/gNtJ4HdMavo/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCS0E92-dofvw1-koCT-YtBVtFY_g",
      "gif": "https://i.ibb.co/bz24TMx/Top-Gun.webp",
      "link": 'https://www.youtube.com/watch?v=gNtJ4HdMavo',
      "channel": 'FilmSpot Trailer',
      "views": "8M",
      "age": 5
    },
    {
      "id": "600ac3b4c90e530062825133",
      "avatar": 'https://i.pravatar.cc/400?img=58',
      "title": 'Drawing Emerald, so Realistic that... 🤑',
      "image": "https://i.ytimg.com/vi/uREmVNd6TQk/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLAk5YgCOxple0MNaU9q0U6OkNDCUw",
      "gif": "https://i.ibb.co/pXH4CBW/Drawing.webp",
      "link": 'https://www.youtube.com/watch?v=uREmVNd6TQk',
      "channel": 'Marcello Barenghi',
      "views": "25M",
      "age": 6
    },
    {
      "id": "600ac3b4c90e530062825134",
      "avatar": 'https://i.pravatar.cc/400?img=59',
      "title": 'New CGI of How Titanic Sank | Titanic 100',
      "image": "https://i.ytimg.com/vi/FSGeskFzE0s/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBKvimTrkUZSS_PZWBVX3dyS5Lgeg",
      "gif": "https://i.ibb.co/9wqV6cP/Titanic.webp",
      "link": 'https://www.youtube.com/watch?v=FSGeskFzE0s',
      "channel": 'National Geographic',
      "views": "35M",
      "age": 2
    },
    {
      "id": "600ac3b4c90e530062825125",
      "avatar": 'https://i.pravatar.cc/400?img=60',
      "title": 'MORTAL KOMBAT 11 Full MOVIE Cutscenes 2020 [4K-60FPS]',
      "image": "https://i.ytimg.com/vi/e0fy8aqe4Aw/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLAzg3rvRnon654pkPz11Hci0BJqYQ",
      "gif": "https://i.ibb.co/YjnDd5N/Mortal-Combat.webp",
      "link": 'https://www.youtube.com/watch?v=e0fy8aqe4Aw',
      "channel": 'lzuniy',
      "views": "337K",
      "age": 4
    },
    {
      "id": "600ac3b4c90e530062825126",
      "avatar": 'https://i.pravatar.cc/400?img=61',
      "title": 'Minecraft | How to Build an Underwater Mountain House',
      "image": "https://i.ytimg.com/vi/n--_I3E05Pk/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCGHd2SI27EZWgcQcObwxz4B65hPA",
      "gif": "https://i.ibb.co/ZcV7jvy/Minecraft.webp",
      "link": 'https://www.youtube.com/watch?v=n--_I3E05Pk',
      "channel": 'Zaypixel',
      "views": "975K",
      "age": 1
    },
    {
      "id": "600ac3b4c90e530062825257",
      "avatar": 'https://i.pravatar.cc/400?img=61',
      "title": 'Beautiful Relaxing Music for Stress Relief • Meditation Music, Sleep Music, Ambient Study Music',
      "image": "https://i.ytimg.com/vi/2OEL4P1Rz04/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBQU5-z0zVVaefKHNDaPoPaRloWig",
      "gif": "https://i.ibb.co/7k57TzN/Mountains.webp",
      "link": 'https://www.youtube.com/watch?v=2OEL4P1Rz04',
      "channel": 'Soothing Relaxation',
      "views": "85M",
      "age": 8
    },
    {
      "id": "600ac3b4c90e530062825a86",
      "avatar": 'https://i.pravatar.cc/400?img=61',
      "title": 'Tom & Jerry | Top 10 Classic Chase Scenes | Classic Cartoon | WB Kids',
      "image": "https://i.ytimg.com/vi/X7R-q9rsrtU/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLAqIi1OBcUGPiMo_WmOhTNNUWWk0Q",
      "gif": "https://i.ibb.co/X3G2hmS/Tom-and-Jerry.webp",
      "link": 'https://www.youtube.com/watch?v=X7R-q9rsrtU',
      "channel": 'WB Kids',
      "views": "15M",
      "age": 6
    },
    {
      "id": "600ac3b4c90e530062825286",
      "avatar": 'https://i.pravatar.cc/400?img=61',
      "title": 'Goals Worth Watching Again',
      "image": "https://i.ytimg.com/vi/HR1ve3s2Pe0/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCMIyovPQ1Y0m9ixgRwSR286pi_6w",
      "gif": "https://i.ibb.co/k4QM21n/Goals.webp",
      "link": 'https://www.youtube.com/watch?v=HR1ve3s2Pe0',
      "channel": 'DNpro',
      "views": "337K",
      "age": 11
    },
  ]